import React, { useState, useEffect } from 'react';

const ChristmasSceneOverlay = () => {
  const [flames, setFlames] = useState([]);

  useEffect(() => {
    // Create flame particles
    const flameCount = 12;
    const initialFlames = Array.from({ length: flameCount }, (_, i) => ({
      id: i,
      x: 35 + Math.random() * 30,
      delay: Math.random() * 2,
      duration: 1.5 + Math.random() * 1,
    }));
    setFlames(initialFlames);
  }, []);

  return (
    <div className="christmas-cabin-overlay">
      <style>
        {`
        .christmas-cabin-overlay {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          z-index: 0;
          pointer-events: none;
          overflow: hidden;
        }

        /* Cozy warm cabin interior background */
        .cabin-interior {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: linear-gradient(
            to bottom,
            #2d1810 0%,
            #3d2418 20%,
            #4a2d1c 40%,
            #5c3a24 70%,
            #6b442c 100%
          );
          z-index: 0;
        }

        /* Window showing snowy night */
        .cabin-window {
          position: absolute;
          top: 8%;
          right: 10%;
          width: 180px;
          height: 200px;
          background: linear-gradient(
            to bottom,
            #0a1628 0%,
            #1e3a5f 50%,
            #2c5282 100%
          );
          border-radius: 10px;
          border: 8px solid #4a2d1c;
          box-shadow: 
            inset 0 0 50px rgba(0, 0, 0, 0.5),
            0 10px 30px rgba(0, 0, 0, 0.8);
          z-index: 1;
        }

        .window-frame-cross {
          position: absolute;
          top: 50%;
          left: 0;
          width: 100%;
          height: 6px;
          background: #3d2418;
          transform: translateY(-50%);
        }

        .window-frame-vertical {
          position: absolute;
          top: 0;
          left: 50%;
          width: 6px;
          height: 100%;
          background: #3d2418;
          transform: translateX(-50%);
        }

        .window-snow {
          position: absolute;
          width: 3px;
          height: 3px;
          background: white;
          border-radius: 50%;
          animation: windowSnowfall linear infinite;
        }

        @keyframes windowSnowfall {
          0% { transform: translateY(-10px) translateX(0); opacity: 0.8; }
          100% { transform: translateY(210px) translateX(10px); opacity: 0.3; }
        }

        /* Fireplace structure */
        .fireplace {
          position: absolute;
          bottom: 10%;
          left: 8%;
          width: 320px;
          height: 260px;
          z-index: 2;
        }

        .fireplace-mantle {
          position: absolute;
          top: 0;
          left: -20px;
          width: 360px;
          height: 30px;
          background: linear-gradient(180deg, #6b442c 0%, #5c3a24 50%, #4a2d1c 100%);
          border-radius: 8px 8px 0 0;
          box-shadow: 
            0 8px 20px rgba(0, 0, 0, 0.7),
            inset 0 2px 5px rgba(255, 255, 255, 0.1);
        }

        .fireplace-body {
          position: absolute;
          top: 30px;
          width: 100%;
          height: 230px;
          background: linear-gradient(135deg, #8b6347 0%, #654321 50%, #4a2d1c 100%);
          border-radius: 5px;
          box-shadow: inset 0 15px 40px rgba(0, 0, 0, 0.6);
        }

        .brick-texture {
          position: absolute;
          top: 30px;
          left: 0;
          width: 100%;
          height: 100%;
        }

        .brick {
          position: absolute;
          width: 40px;
          height: 20px;
          background: linear-gradient(135deg, #a0522d 0%, #8b4513 50%, #654321 100%);
          border-radius: 2px;
          box-shadow: inset -2px -2px 4px rgba(0, 0, 0, 0.3);
        }

        .fireplace-opening {
          position: absolute;
          top: 60px;
          left: 30px;
          width: 260px;
          height: 160px;
          background: linear-gradient(
            to top,
            #1a0f0a 0%,
            #2d1810 40%,
            #1a0f0a 100%
          );
          border-radius: 130px 130px 0 0;
          box-shadow: 
            inset 0 -25px 50px rgba(255, 80, 0, 0.7),
            inset 0 15px 40px rgba(0, 0, 0, 0.9);
        }

        /* Animated fire flames */
        .fire-container {
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
          width: 220px;
          height: 120px;
        }

        .flame {
          position: absolute;
          bottom: 0;
          width: 35px;
          height: 70px;
          background: linear-gradient(
            to top,
            #ff4500 0%,
            #ff6600 30%,
            #ff8c00 50%,
            #ffa500 65%,
            #ffd700 80%,
            rgba(255, 255, 200, 0.9) 100%
          );
          border-radius: 50% 50% 0 0;
          filter: blur(10px);
          animation: flameFlicker ease-in-out infinite;
          box-shadow: 0 0 40px rgba(255, 100, 0, 0.9);
        }

        @keyframes flameFlicker {
          0%, 100% { 
            transform: translateY(0) scaleY(1) scaleX(1);
            opacity: 0.95;
          }
          20% { 
            transform: translateY(-10px) scaleY(1.2) scaleX(0.93);
            opacity: 1;
          }
          40% { 
            transform: translateY(-15px) scaleY(1.3) scaleX(0.88);
            opacity: 0.98;
          }
          60% { 
            transform: translateY(-12px) scaleY(1.25) scaleX(0.9);
            opacity: 0.96;
          }
          80% { 
            transform: translateY(-8px) scaleY(1.15) scaleX(0.95);
            opacity: 0.94;
          }
        }

        /* Fire logs */
        .fire-logs {
          position: absolute;
          bottom: -5px;
          left: 50%;
          transform: translateX(-50%);
          width: 180px;
          height: 30px;
        }

        .log {
          position: absolute;
          bottom: 0;
          width: 80px;
          height: 20px;
          background: linear-gradient(90deg, #3d2817 0%, #2d1810 100%);
          border-radius: 10px;
          box-shadow: inset 0 -3px 6px rgba(0, 0, 0, 0.5);
        }

        /* Fire glow */
        .fire-glow {
          position: absolute;
          bottom: -30px;
          left: 50%;
          transform: translateX(-50%);
          width: 320px;
          height: 200px;
          background: radial-gradient(
            ellipse at center,
            rgba(255, 100, 0, 0.5) 0%,
            rgba(255, 130, 0, 0.3) 30%,
            rgba(255, 150, 0, 0.15) 50%,
            transparent 75%
          );
          filter: blur(35px);
          animation: glowPulse 2.5s ease-in-out infinite;
        }

        @keyframes glowPulse {
          0%, 100% { opacity: 0.7; }
          50% { opacity: 1; }
        }

        /* Stockings on mantle */
        .stocking {
          position: absolute;
          top: -8px;
          width: 35px;
          height: 50px;
        }

        .stocking-main {
          width: 25px;
          height: 35px;
          background: linear-gradient(135deg, #dc143c 0%, #8b0000 100%);
          border-radius: 5px;
        }

        .stocking-foot {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 35px;
          height: 18px;
          background: linear-gradient(135deg, #dc143c 0%, #8b0000 100%);
          border-radius: 0 8px 8px 0;
        }

        .stocking-trim {
          position: absolute;
          top: 0;
          width: 100%;
          height: 8px;
          background: white;
          border-radius: 5px 5px 0 0;
        }

        /* Christmas tree */
        .christmas-tree {
          position: absolute;
          bottom: 10%;
          right: 10%;
          width: 240px;
          height: 340px;
          z-index: 3;
        }

        .tree-layers-container {
          position: relative;
          width: 100%;
          height: 290px;
        }

        .tree-layer-section {
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          width: 0;
          height: 0;
          border-style: solid;
          filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.4));
        }

        .tree-trunk {
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
          width: 30px;
          height: 60px;
          background: linear-gradient(90deg, #3d2817 0%, #5c4033 50%, #3d2817 100%);
          border-radius: 4px;
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.5);
        }

        /* Tree star topper */
        .tree-star {
          position: absolute;
          top: -25px;
          left: 50%;
          transform: translateX(-50%);
          width: 35px;
          height: 35px;
          background: linear-gradient(135deg, #ffd700 0%, #ffed4e 50%, #ffd700 100%);
          clip-path: polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%);
          animation: starGlow 1.8s ease-in-out infinite;
          box-shadow: 0 0 25px rgba(255, 215, 0, 1);
        }

        @keyframes starGlow {
          0%, 100% { 
            filter: brightness(1.2);
            box-shadow: 0 0 25px rgba(255, 215, 0, 1);
          }
          50% { 
            filter: brightness(1.8);
            box-shadow: 0 0 40px rgba(255, 215, 0, 1), 0 0 60px rgba(255, 215, 0, 0.6);
          }
        }

        /* Tree ornaments */
        .ornament {
          position: absolute;
          width: 12px;
          height: 14px;
          border-radius: 50% 50% 45% 45%;
          animation: ornamentSway ease-in-out infinite;
          box-shadow: inset -2px -2px 4px rgba(0, 0, 0, 0.3);
        }

        @keyframes ornamentSway {
          0%, 100% { transform: rotate(-2deg); }
          50% { transform: rotate(2deg); }
        }

        .ornament-cap {
          position: absolute;
          top: -3px;
          left: 50%;
          transform: translateX(-50%);
          width: 6px;
          height: 3px;
          background: #ffd700;
          border-radius: 2px 2px 0 0;
        }

        /* Tree lights */
        .tree-light {
          position: absolute;
          width: 8px;
          height: 10px;
          border-radius: 50% 50% 40% 40%;
          animation: lightTwinkle ease-in-out infinite;
        }

        @keyframes lightTwinkle {
          0%, 100% { opacity: 0.8; filter: brightness(1); }
          50% { opacity: 1; filter: brightness(1.5); }
        }

        /* Presents under tree */
        .presents-container {
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
          width: 180px;
          height: 60px;
        }

        .present {
          position: absolute;
          bottom: 0;
          border-radius: 3px;
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.4);
        }

        .present-ribbon {
          position: absolute;
          top: 50%;
          left: 0;
          width: 100%;
          height: 8px;
          transform: translateY(-50%);
          border-radius: 2px;
        }

        .present-ribbon-vertical {
          position: absolute;
          top: 0;
          left: 50%;
          width: 8px;
          height: 100%;
          transform: translateX(-50%);
          border-radius: 2px;
        }

        .present-bow {
          position: absolute;
          top: -8px;
          left: 50%;
          transform: translateX(-50%);
          width: 20px;
          height: 20px;
        }

        .bow-loop {
          position: absolute;
          width: 12px;
          height: 12px;
          border-radius: 50%;
          background: currentColor;
        }

        .bow-loop.left {
          left: -8px;
          top: 4px;
        }

        .bow-loop.right {
          right: -8px;
          top: 4px;
        }

        .bow-center {
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          width: 8px;
          height: 8px;
          background: currentColor;
          border-radius: 50%;
        }

        /* Wreath on wall */
        .wreath {
          position: absolute;
          top: 15%;
          left: 15%;
          width: 100px;
          height: 100px;
          z-index: 1;
        }

        .wreath-ring {
          width: 100%;
          height: 100%;
          border: 18px solid #2d5016;
          border-radius: 50%;
          box-shadow: 
            inset 0 0 15px rgba(0, 0, 0, 0.3),
            0 5px 20px rgba(0, 0, 0, 0.5);
        }

        .wreath-bow {
          position: absolute;
          bottom: -5px;
          left: 50%;
          transform: translateX(-50%);
          width: 30px;
          height: 30px;
        }

        .wreath-ribbon {
          position: absolute;
          width: 16px;
          height: 16px;
          background: #dc143c;
          border-radius: 50%;
        }

        .wreath-ribbon.left {
          left: -10px;
          top: 5px;
        }

        .wreath-ribbon.right {
          right: -10px;
          top: 5px;
        }

        .wreath-ribbon-center {
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          width: 12px;
          height: 12px;
          background: #dc143c;
          border-radius: 50%;
        }

        /* String lights along top */
        .string-lights {
          position: absolute;
          top: 5%;
          left: 0;
          width: 100%;
          height: 50px;
          z-index: 4;
        }

        .light-bulb-string {
          position: absolute;
          width: 12px;
          height: 16px;
          border-radius: 50% 50% 45% 45%;
          animation: bulbGlow ease-in-out infinite;
        }

        @keyframes bulbGlow {
          0%, 100% { opacity: 0.7; transform: translateY(0); }
          50% { opacity: 1; transform: translateY(2px); }
        }

        .light-wire {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 2px;
          background: linear-gradient(
            90deg,
            transparent 0%,
            #2d1810 5%,
            #2d1810 95%,
            transparent 100%
          );
        }

        /* Warm cabin glow overlay */
        .warm-glow {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: radial-gradient(
            ellipse at 18% 55%,
            rgba(255, 120, 0, 0.2) 0%,
            rgba(255, 100, 0, 0.1) 30%,
            transparent 55%
          );
          z-index: 5;
          pointer-events: none;
        }

        /* Candles on mantle */
        .candle {
          position: absolute;
          bottom: 2px;
          width: 12px;
          height: 35px;
        }

        .candle-body {
          width: 100%;
          height: 30px;
          background: linear-gradient(90deg, #f5f5dc 0%, #fffacd 50%, #f5f5dc 100%);
          border-radius: 2px 2px 0 0;
          box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
        }

        .candle-flame {
          position: absolute;
          top: -10px;
          left: 50%;
          transform: translateX(-50%);
          width: 8px;
          height: 12px;
          background: linear-gradient(to top, #ff8c00 0%, #ffa500 40%, #ffd700 70%, rgba(255, 255, 150, 0.8) 100%);
          border-radius: 50% 50% 0 0;
          filter: blur(2px);
          animation: candleFlicker 1.5s ease-in-out infinite;
          box-shadow: 0 0 15px rgba(255, 165, 0, 0.8);
        }

        @keyframes candleFlicker {
          0%, 100% { transform: translateX(-50%) scaleY(1); opacity: 0.9; }
          50% { transform: translateX(-50%) scaleY(1.15); opacity: 1; }
        }

        /* Wooden floor */
        .wooden-floor {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 12%;
          background: linear-gradient(
            to bottom,
            #4a2d1c 0%,
            #3d2418 100%
          );
          z-index: 6;
          box-shadow: 0 -10px 30px rgba(0, 0, 0, 0.5);
        }

        .floor-plank {
          position: absolute;
          width: 100%;
          height: 2px;
          background: rgba(0, 0, 0, 0.2);
        }
        `}
      </style>

      {/* Cabin interior background */}
      <div className="cabin-interior" />

      {/* Window showing snowy night */}
      <div className="cabin-window">
        <div className="window-frame-cross" />
        <div className="window-frame-vertical" />
        {Array.from({ length: 15 }, (_, i) => (
          <div
            key={i}
            className="window-snow"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 50}%`,
              animationDuration: `${3 + Math.random() * 4}s`,
              animationDelay: `${Math.random() * 3}s`,
            }}
          />
        ))}
      </div>

      {/* Wreath on wall */}
      <div className="wreath">
        <div className="wreath-ring" />
        <div className="wreath-bow">
          <div className="wreath-ribbon left" />
          <div className="wreath-ribbon right" />
          <div className="wreath-ribbon-center" />
        </div>
      </div>

      {/* String lights along ceiling */}
      <div className="string-lights">
        <div className="light-wire" />
        {[
          { pos: 10, color: '#ff0000', delay: 0 },
          { pos: 20, color: '#00ff00', delay: 0.3 },
          { pos: 30, color: '#ffd700', delay: 0.6 },
          { pos: 40, color: '#0000ff', delay: 0.9 },
          { pos: 50, color: '#ff00ff', delay: 1.2 },
          { pos: 60, color: '#ff0000', delay: 1.5 },
          { pos: 70, color: '#00ff00', delay: 1.8 },
          { pos: 80, color: '#ffd700', delay: 2.1 },
          { pos: 90, color: '#0000ff', delay: 2.4 },
        ].map((light, i) => (
          <div
            key={i}
            className="light-bulb-string"
            style={{
              left: `${light.pos}%`,
              top: '20px',
              backgroundColor: light.color,
              boxShadow: `0 0 15px ${light.color}`,
              animationDelay: `${light.delay}s`,
              animationDuration: '2.5s',
            }}
          />
        ))}
      </div>

      {/* Fireplace with animated fire */}
      <div className="fireplace">
        <div className="fireplace-mantle">
          {/* Candles on mantle */}
          <div className="candle" style={{ left: '20px' }}>
            <div className="candle-body" />
            <div className="candle-flame" style={{ animationDelay: '0s' }} />
          </div>
          <div className="candle" style={{ left: '60px' }}>
            <div className="candle-body" />
            <div className="candle-flame" style={{ animationDelay: '0.5s' }} />
          </div>
          
          {/* Stockings */}
          <div className="stocking" style={{ left: '100px' }}>
            <div className="stocking-trim" />
            <div className="stocking-main" />
            <div className="stocking-foot" />
          </div>
          <div className="stocking" style={{ left: '150px' }}>
            <div className="stocking-trim" />
            <div className="stocking-main" />
            <div className="stocking-foot" />
          </div>
          <div className="stocking" style={{ left: '200px' }}>
            <div className="stocking-trim" />
            <div className="stocking-main" />
            <div className="stocking-foot" />
          </div>
          
          {/* More candles */}
          <div className="candle" style={{ right: '60px' }}>
            <div className="candle-body" />
            <div className="candle-flame" style={{ animationDelay: '0.3s' }} />
          </div>
          <div className="candle" style={{ right: '20px' }}>
            <div className="candle-body" />
            <div className="candle-flame" style={{ animationDelay: '0.8s' }} />
          </div>
        </div>
        <div className="fireplace-body">
          <div className="fireplace-opening">
            <div className="fire-container">
              {/* Animated flames */}
              {flames.map((flame) => (
                <div
                  key={flame.id}
                  className="flame"
                  style={{
                    left: `${flame.x}%`,
                    animationDuration: `${flame.duration}s`,
                    animationDelay: `${flame.delay}s`,
                  }}
                />
              ))}
              {/* Fire logs */}
              <div className="fire-logs">
                <div className="log" style={{ left: '10px', transform: 'rotate(-5deg)' }} />
                <div className="log" style={{ left: '50px', transform: 'rotate(8deg)' }} />
              </div>
            </div>
          </div>
          {/* Fire glow */}
          <div className="fire-glow" />
        </div>
      </div>

      {/* Christmas tree with decorations */}
      <div className="christmas-tree">
        <div className="tree-layers-container">
          {/* Tree star */}
          <div className="tree-star" />
          
          {/* Tree layers */}
          <div
            className="tree-layer-section"
            style={{
              bottom: '170px',
              borderLeft: '55px solid transparent',
              borderRight: '55px solid transparent',
              borderBottom: '85px solid #1a5d2e',
            }}
          />
          <div
            className="tree-layer-section"
            style={{
              bottom: '115px',
              borderLeft: '75px solid transparent',
              borderRight: '75px solid transparent',
              borderBottom: '95px solid #1a5d2e',
            }}
          />
          <div
            className="tree-layer-section"
            style={{
              bottom: '50px',
              borderLeft: '95px solid transparent',
              borderRight: '95px solid transparent',
              borderBottom: '105px solid #1a5d2e',
            }}
          />
          
          {/* Ornaments */}
          {[
            { x: 45, y: 185, color: '#ff0000', delay: 0 },
            { x: 55, y: 190, color: '#ffd700', delay: 0.5 },
            { x: 35, y: 145, color: '#0000ff', delay: 1 },
            { x: 65, y: 150, color: '#ff00ff', delay: 1.5 },
            { x: 50, y: 115, color: '#00ff00', delay: 2 },
            { x: 40, y: 85, color: '#ff8800', delay: 2.5 },
            { x: 60, y: 90, color: '#ff0088', delay: 3 },
            { x: 48, y: 60, color: '#00ffff', delay: 3.5 },
            { x: 52, y: 65, color: '#ffff00', delay: 4 },
          ].map((orn, i) => (
            <div
              key={i}
              className="ornament"
              style={{
                left: `${orn.x}%`,
                bottom: `${orn.y}px`,
                background: `radial-gradient(circle at 30% 30%, ${orn.color}ee 0%, ${orn.color} 60%, ${orn.color}88 100%)`,
                animationDuration: '3.5s',
                animationDelay: `${orn.delay}s`,
              }}
            >
              <div className="ornament-cap" />
            </div>
          ))}

          {/* Tree lights */}
          {[
            { x: 48, y: 200, color: '#ffff00', delay: 0 },
            { x: 52, y: 195, color: '#ff0000', delay: 0.4 },
            { x: 38, y: 160, color: '#00ff00', delay: 0.8 },
            { x: 62, y: 165, color: '#0000ff', delay: 1.2 },
            { x: 45, y: 130, color: '#ff00ff', delay: 1.6 },
            { x: 55, y: 125, color: '#ffff00', delay: 2 },
            { x: 50, y: 80, color: '#ff0000', delay: 2.4 },
            { x: 42, y: 55, color: '#00ff00', delay: 2.8 },
            { x: 58, y: 50, color: '#ffd700', delay: 3.2 },
          ].map((light, i) => (
            <div
              key={i}
              className="tree-light"
              style={{
                left: `${light.x}%`,
                bottom: `${light.y}px`,
                backgroundColor: light.color,
                boxShadow: `0 0 15px ${light.color}`,
                animationDuration: '2.2s',
                animationDelay: `${light.delay}s`,
              }}
            />
          ))}

          {/* Tree trunk */}
          <div className="tree-trunk" />
        </div>

        {/* Presents under tree */}
        <div className="presents-container">
          {/* Large red present */}
          <div
            className="present"
            style={{
              left: '10px',
              width: '50px',
              height: '45px',
              background: 'linear-gradient(135deg, #dc143c 0%, #8b0000 100%)',
            }}
          >
            <div className="present-ribbon" style={{ background: '#ffd700' }} />
            <div className="present-ribbon-vertical" style={{ background: '#ffd700' }} />
            <div className="present-bow" style={{ color: '#ffd700' }}>
              <div className="bow-loop left" />
              <div className="bow-loop right" />
              <div className="bow-center" />
            </div>
          </div>

          {/* Medium green present */}
          <div
            className="present"
            style={{
              left: '70px',
              width: '40px',
              height: '38px',
              background: 'linear-gradient(135deg, #228b22 0%, #006400 100%)',
            }}
          >
            <div className="present-ribbon" style={{ background: '#dc143c' }} />
            <div className="present-ribbon-vertical" style={{ background: '#dc143c' }} />
            <div className="present-bow" style={{ color: '#dc143c' }}>
              <div className="bow-loop left" />
              <div className="bow-loop right" />
              <div className="bow-center" />
            </div>
          </div>

          {/* Small blue present */}
          <div
            className="present"
            style={{
              left: '120px',
              width: '35px',
              height: '32px',
              background: 'linear-gradient(135deg, #4169e1 0%, #000080 100%)',
            }}
          >
            <div className="present-ribbon" style={{ background: '#ffd700' }} />
            <div className="present-ribbon-vertical" style={{ background: '#ffd700' }} />
            <div className="present-bow" style={{ color: '#ffd700' }}>
              <div className="bow-loop left" />
              <div className="bow-loop right" />
              <div className="bow-center" />
            </div>
          </div>
        </div>
      </div>

      {/* Warm fire glow overlay */}
      <div className="warm-glow" />

      {/* Wooden floor */}
      <div className="wooden-floor">
        {[20, 40, 60, 80].map((pos) => (
          <div
            key={pos}
            className="floor-plank"
            style={{ top: `${pos}%` }}
          />
        ))}
      </div>
    </div>
  );
};

export default ChristmasSceneOverlay;
